import { ReactElement } from 'react';
import { LedgerRow, sourceLabel, summarizeBySource, summarizeByType } from './ledgerRows';
import { Amount, Count, Head, SummaryTable, SummaryTables, Who } from './SummaryCells';

/** The prototype's two summary tables over the listed rows: by type and by source. Both total the same Net. */

export function LedgerSummary({ rows }: { rows: LedgerRow[] }): ReactElement {
  const byType = summarizeByType(rows);
  const bySource = summarizeBySource(rows);

  return (
    <SummaryTables>
      <SummaryTable label="By type">
        <thead>
          <tr>
            <Head who>Type</Head>
            <Head>Count</Head>
            <Head>Amount</Head>
            <Head>Merchant fees</Head>
            <Head>Net</Head>
          </tr>
        </thead>
        <tbody>
          {byType.rows.map((row) => (
            <tr key={row.type}>
              <Who>{row.type}</Who>
              <Count value={row.count} />
              <Amount value={row.amount} />
              <Amount value={row.fee} sign />
              <Amount value={row.net} bold />
            </tr>
          ))}
          <tr>
            <Who total>Total</Who>
            <Count value={byType.total.count} total />
            <Amount value={byType.total.amount} total />
            <Amount value={byType.total.fee} sign total />
            <Amount value={byType.total.net} bold total />
          </tr>
        </tbody>
      </SummaryTable>

      <SummaryTable label="By source">
        <thead>
          <tr>
            <Head who>Source</Head>
            <Head>Payments</Head>
            <Head>Refunds</Head>
            <Head>Customer service fees</Head>
            <Head>Merchant fees</Head>
            <Head>Net</Head>
          </tr>
        </thead>
        <tbody>
          {bySource.rows.map((row) => (
            <tr key={row.source}>
              <Who>{sourceLabel(row.source)}</Who>
              <Amount value={row.payments} />
              <Amount value={row.refunds} />
              <Amount value={row.customerServiceFees} />
              <Amount value={row.fee} sign />
              <Amount value={row.net} bold />
            </tr>
          ))}
          <tr>
            <Who total>Total</Who>
            <Amount value={bySource.total.payments} total />
            <Amount value={bySource.total.refunds} total />
            <Amount value={bySource.total.customerServiceFees} total />
            <Amount value={bySource.total.fee} sign total />
            <Amount value={bySource.total.net} bold total />
          </tr>
        </tbody>
      </SummaryTable>
    </SummaryTables>
  );
}
